export default {
    en:{
        col:'조직',
        empNo:'교원',
        period:'기간',
        downloadExcel:'표 다운로드',
        exportData:'데이터 다운로드',
        sourceyear:'출판년월',
        sci:'SCI',
        scie:'SCIE',
        ssci:'SSCI',
        ahci:'A&HCI',
        scopus:'SCOPUS',
        rank1s:'최고권위지',
        rank11:'국제1등급',
        rank12:'국제2등급',
        rank13:'국제3등급',
        rank14:'국제4등급',
        rank21:'국내1등급',
        rank22:'국내2등급',
        rank23:'국내3등급',
        rank24:'국내4등급',
        rank25:'N.C.S급',
        all:'전체',
    },
    ko:{
        col:'조직',
        empNo:'교원',
        period:'기간',
        downloadExcel:'표 다운로드',
        exportData:'데이터 다운로드',
        sourceyear:'출판년월',
        sci:'SCI',
        scie:'SCIE',
        ssci:'SSCI',
        ahci:'A&HCI',
        scopus:'SCOPUS',
        rank1s:'최고권위지',
        rank11:'국제1등급',
        rank12:'국제2등급',
        rank13:'국제3등급',
        rank14:'국제4등급',
        rank21:'국내1등급',
        rank22:'국내2등급',
        rank23:'국내3등급',
        rank24:'국내4등급',
        rank25:'N.C.S급',
        all:'전체',

    }
}